module.exports = __webpack_public_path__ + "static/media/spam.f740fa5d.svg";